/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function Image2dItemFromJSON(json) {
    return Image2dItemFromJSONTyped(json, false);
}
export function Image2dItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'file': !exists(json, 'file') ? undefined : json['file'],
        'widthInMeters': !exists(json, 'width_in_meters') ? undefined : json['width_in_meters'],
    };
}
export function Image2dItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'file': value.file,
        'width_in_meters': value.widthInMeters,
    };
}
//# sourceMappingURL=Image2dItem.js.map